import Command from '@ckeditor/ckeditor5-core/src/command';
import { insertPlaceholderImage } from './clipboard-input-handler';

// convert selected text to annotation
class ConvertToAnnotationCommand extends Command {
  execute({ value, fieldType, itemId }) {
    const editor = this.editor;

    // handle special annotation
    const specialAnnotations = [];
    if (specialAnnotations.includes(fieldType)) {
      insertPlaceholderImage(editor, fieldType, itemId);
      return;
    }

    // otherwise, convert to regular text annotation
    editor.model.change((writer) => {
      // Create a <placeholder> element with the "name" attribute (and all the selection attributes)...
      const annotation = writer.createElement('annotation', {
        displayLabel: `{{ ${value} }}`,
        itemId,
        itemFieldType: fieldType,
        width: `${value.length + 1}em`,
      });

      // ... and insert it into the document.
      editor.model.insertContent(annotation);

      // Put the selection on the inserted element.
      writer.setSelection(annotation, 'on');
    });
  }

  refresh() {
    const model = this.editor.model;
    const selection = model.document.selection;

    const isAllowed = model.schema.checkChild(selection.focus.parent, 'annotation');

    this.isEnabled = isAllowed;
  }
}

export default ConvertToAnnotationCommand;
